import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@mangosoft/mango-layout';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-modal-alert',
	templateUrl: './modal-alert.component.html',
	styleUrls: ['./modal-alert.component.scss'],
})
export class ModalAlertComponent implements OnInit, OnDestroy {
	content: any;
	@Output() closeModalAlert: EventEmitter<any> = new EventEmitter();
	@Input() nameModal: string = '';
	@Input() value: string = '';
	@Input() elementsDelete: string = '';
	subscriptionTranslate!: Subscription;

	constructor(private translateService: TranslateService) {}

	ngOnInit(): void {
		this.getTranslate();
	}

	getTranslate() {
		this.subscriptionTranslate = this.translateService.init('AccessControl').subscribe((data) => {
			this.content = data.components[this.nameModal || 'modalAlertDeleteNoSelected'];
		});
	}

	closeModal(value: boolean) {
		this.closeModalAlert.emit({ resp: value, value: this.value });
	}

	ngOnDestroy(): void {
		this.subscriptionTranslate?.unsubscribe();
	}
}
